import { render } from "./HeroiconsSolidBadgeCheck.vue?vue&type=template&id=72d7d4d7"
const script = {}

import exportComponent from "/Users/thuanluu/code/owlx/more9_venues/package/private/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidBadgeCheck.vue"]])

export default __exports__